;(function($){

  /**
   * コンセプト
   *
   * @constructor
   */
  function Concept() {
    /* ----------------------------------------------------
     * Private Property
     * ------------------------------------------------- */

    var props = {
      fps: 10,
      offset: 300,
      isScrolling: false,
      scrollTop: 0,
      winWidth : 0,
      winHeight: 0,
      conceptHeight: 0,
      scrollElements: [],
      scrollElementLength: 0,
      leafTypes: 12,
      leavesTotal: 10,
      leavesDelay: 200,
      leavesPath: 'assets/images/index/concept/sprite-leaf.png',
      className: {
        enter: 'can-enter',
        active: 'is-active',
        leaf  : 'falling_leaf'
      },
      label: {
        enterEvent  : 'enterOnScroll',
        addClassFunc: 'addClassFunc'
      },
      loopFuncs: {},
      $elm: {
        concept: $('#Concept')
      }
    };

    props.frameTime = 1000 / props.fps;

    // temporary workaround for chrome's scroll jitter bug
    // from ScrollMagic
    window.addEventListener('mousewheel', function () {});


    /* ----------------------------------------------------
     * Public API
     * ------------------------------------------------- */

    this.init = function() {
      bindScroll();
      tick();
      loadImages().always(function() {
        var leaves = new Leaf($('#Concept'));

        leaves.run();
        setElementProps();
        addClassWhenPassed();
      });
    }


    /* ----------------------------------------------------
     * Private Method
     * ------------------------------------------------- */
    
    /**
     * スクロールイベントをバインド
     */
    function bindScroll() {
      handleScroll();
      $(window).on('scroll.' + props.label.enterEvent, handleScroll);
    }

    /**
     * スクロールにフラグをセットする
     */
    function handleScroll() {
      props.isScrolling = true;
    }

    /**
     * 指定したFPSでループ処理を実行する
     */
    function tick() {
      var lastCalled = Date.now();

      (function loop() {
        var now = Date.now();

        requestAnimationFrame(loop);

        if (!props.isScrolling) return;

        if (now > lastCalled + props.frameTime) {
          props.isScrolling = false;
          lastCalled = now;
          Object.keys(props.loopFuncs).forEach(function(key) {
            props.loopFuncs[key]();
          });
        }
      })();
    }

    /**
     * RAFに関数を追加
     *
     * @param {string} key 関数を指定するキー
     * @param {function} func 実行する関数
     */
    function addLoop(key, func) {
      props.loopFuncs[key] = func;
    }

    /**
     * RAFから関数を削除
     *
     * @param {string} addの時に指定したキー
     */
    function removeLoop(key) {
      delete props.loopFuncs[key];
    }

    function loadImages() {
      var images = [];
      var defer  = new $.Deferred();

      props.$elm.concept.find('img').each(function() {
        images.push($(this).attr('src'));
      });

      images.push(props.leavesPath);

      LIB.ImagesLoader(images, {complete: function(hoge) {
        defer.resolve();
      }});

      return defer.promise();
    }

    /**
     * 要素の位置にスクロールが達したらクラスを付与する
     *
     * 読み込み時にtickへ追加し、
     * 全ての要素が表示されたらtickから削除する
     */
    function addClassWhenPassed() {
      addLoop(props.label.addClassFunc, function() {
        var visibleLine, item;
        var finished = true;

        props.scrollTop = $(window).scrollTop();
        visibleLine = props.scrollTop + props.winHeight - props.offset;

        for (var i = 0; i < props.scrollElementLength; i++) {
          if (!props.scrollElements[i].visible) {
            if (visibleLine > props.scrollElements[i].top) {
              props.scrollElements[i].visible = true;
              props.scrollElements[i].$dom.addClass(props.className.active);
            }
            finished = false;
          }
        }

        if (finished) {
          $(window).off('scroll.' + props.label.enterEvent);
          removeLoop(props.label.addClassFunc)
        }
      });
    }

    /**
     * 要素の位置・Windowの高さの取得
     *
     * 毎回取得すると負荷がかかるので、
     * 初回とリサイズ時に実行
     */
    function setElementProps() {
      var set = function() {
        props.winWidth  = $(window).innerWidth();
        props.winHeight = $(window).innerHeight();
        props.conceptHeight = props.$elm.concept.innerHeight();

        $('.' + props.className.enter).each(function() {
          props.scrollElements.push({
            $dom: $(this),
            top: $(this).offset().top,
            visible: $(this).hasClass(props.className.active) ? true : false
          });
        });
        props.scrollElementLength = props.scrollElements.length;
      };

      set();
      $(window).on('resize', set);
    }
  }

  window.Concept = new Concept();
})(jQuery);